// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3cYWU","title":"FrontImage_title__pH-gi"};